import React, { useState, useEffect } from 'react'
import ImportOriginalSpareParts from 'src/pages/ReportsPages/ReportsBoard/SpareParts/ImportOriginalSpareParts'
import boardReportsService from 'src/services/boardReportsService'

const ImportsOriginalSparePartsContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [total1, setTotal1] = useState([])
  const [gTotal1, setGTotal1] = useState([])
  const [total2, setTotal2] = useState([])
  const [total3, setTotal3] = useState([])

  const reloadImportsTotal = async () => {
    const [query1, gQuery1, query2, query3] = await Promise.all([
      boardReportsService.getTotalImports('5', selectedDate.getFullYear(), 'tipo=ORIGINAL'),
      boardReportsService.getGTotalImports('2', selectedDate.getFullYear(), 'tipo=ORIGINAL'),
      boardReportsService.getTotalImports('6', selectedDate.getFullYear(), 'tipo=ORIGINAL'),
      boardReportsService.getTotalImports('7', selectedDate.getFullYear(), 'tipo=ORIGINAL'),
    ])
    setTotal1(query1)
    setGTotal1(gQuery1)
    setTotal2(query2)
    setTotal3(query3 || [])
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadImportsTotal()
  }, [])

  return (
    <ImportOriginalSpareParts
      total1={total1}
      total2={total2}
      total3={total3}
      gTotal1={gTotal1}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default ImportsOriginalSparePartsContainer
